(() => {
  const SINGLE_SELECT_LABELS = ['Protect Your Purchase'];

  const GROUP_SELECTOR = '.po-option-root';
  const LABEL_SELECTOR = '.po-label-label';
  const CHECKBOX_SELECTOR = 'input.po-checkboxOption-checkbox';

  function isSingleSelectGroup(group) {
    const label = group.querySelector(LABEL_SELECTOR);
    if (!label) return false;
    return SINGLE_SELECT_LABELS.includes(label.textContent.trim());
  }

  function enforceSingleSelect(group, changed) {
    group.querySelectorAll(CHECKBOX_SELECTOR).forEach((checkbox) => {
      if (checkbox === changed) return;
      if (!checkbox.checked) return;
      checkbox.click();
    });
  }

  function enhanceGroup(group) {
    if (group.dataset.easifySingleSelect === 'true') return;
    if (!isSingleSelectGroup(group)) return;
    group.dataset.easifySingleSelect = 'true';

    group.addEventListener('change', (event) => {
      const changed = event.target;
      if (!(changed instanceof HTMLInputElement)) return;
      if (!changed.matches(CHECKBOX_SELECTOR)) return;
      if (!changed.checked) return;
      if (group.dataset.easifyEnforcing === 'true') return;
      group.dataset.easifyEnforcing = 'true';
      enforceSingleSelect(group, changed);
      delete group.dataset.easifyEnforcing;
    });
  }

  function enhance(root) {
    const scope = root instanceof Element ? root : document;
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll(GROUP_SELECTOR).forEach(enhanceGroup);
  }

  function observeProductInfo(productInfo) {
    if (!productInfo || productInfo.dataset.easifySingleSelectObserved === 'true') return;
    productInfo.dataset.easifySingleSelectObserved = 'true';

    enhance(productInfo);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          enhance(node);
        });
      });
    });

    observer.observe(productInfo, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('product-info').forEach(observeProductInfo);
  }

  window.EasifySingleSelectCheckboxes = {
    enhance,
    observe: observeProductInfo,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
